import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PollsandsurveyService } from 'src/app/services/pollsandsurvey.service';

@Component({
  standalone: false,
  selector: 'app-remove-modal-coupon-survey',
  templateUrl: './remove-modal-coupon-survey.component.html',
  styleUrls: ['./remove-modal-coupon-survey.component.scss'],
})
export class RemovemodalcouponsurveyComponent implements OnInit {
  @Input() couponId: string;
  @Input() fromDetailsPage: any;
  @Input() fromListPage: any;
  @Input() surveyId: any;

  listCouponIds = [];

  myForm!: FormGroup;

  constructor(
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private router: Router,
    private pollsandsurveyService: PollsandsurveyService
  ) {
    this.myForm = this.formBuilder.group({
      deletedBy: '',
      userId: ''
    });
  }

  ngOnInit(): void { }

  deleteSurveyData() {
    this.listCouponIds = [];
    this.pollsandsurveyService
      .removeSurvey(this.surveyId)
      .subscribe((res) => {
        console.log(res);
        if (res.isValid) {
          if(this.fromDetailsPage == 'no') {
            location.reload();
          }
          if(this.fromDetailsPage == 'yes') {
            this.router.navigate(['/list-survey/']);
          }
        }
      });
    this.modal.dismiss();
  }
}
